// extracted by mini-css-extract-plugin
module.exports = {"modalActions":"CreateCollectionModal_modalActions__12pfz","formGroup":"CreateCollectionModal_formGroup__1Yliy"};